export default __webpack_public_path__ + "static/placeholder-8068171b22acbab2a13c0fe85ac0e2d6.webp";